<div class="documentsRectangle">
  <h2>Documents</h2>
  @if (!isLoading) {
    <div class="pdf-list">
      @for (document of documents; track document) {
        <button
          mat-button
          class="pdf-item"
          (click)="openDocument(document)"
          >
          <mat-icon class="pdf-symbol">description</mat-icon>
          {{ document.DocumentType }}
        </button>
      }
    </div>
  }
  <!-- No documents message -->
  @if (documents.length === 0 && !isLoading) {
    <div class="no-records-found">
      <p>No documents found.</p>
    </div>
  }
  <!-- Spinner -->
  @if (isLoading) {
    <div class="spinner-overlay">
      <mat-progress-spinner
        mode="indeterminate"
        [diameter]="30"
        class="spinner"
      ></mat-progress-spinner>
    </div>
  }
</div>
